import DialogPlusPage from "@/componentsUI/DialogPage/dialogPlusPage";
import { min, sample } from "lodash-es";

import React, { useEffect, useMemo, useRef, useState } from "react";
import Wheel from "@/features/invite/dialogInviteWheel/component/wheel/Wheel";
import { StatisticCountdown } from "@/componentsUI/Statistic";
import "./index.less";
import UserList from "@/features/invite/dialogInviteWheel/component/userList/UserList";
import ButtonUI from "@/componentsUI/Button";
import ProgressBar from "@/features/invite/dialogInviteWheel/component/progressBar/ProgressBar";
import DialogWheelHeader from "@/features/invite/dialogInviteWheel/component/dialogHeader/DialogWheelHeader";
import MoneyPath from "./assets/bg_mimiqian.webp";
import WheelBgPath from "./assets/bg_zhuangshi.webp";
import WheelPointerPath from "./assets/bg_zhizhen.webp";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { debounce } from "@/Core/utils";
import copy from "copy-to-clipboard";
import Help from "@/features/invite/dialogInviteWheel/component/help/Help";
import ShareIcon from "./assets/fengxiang.svg";
import { buildInviteLink } from "@/features/invite/inviteLink";
import { useCurrency } from "@/hooks/useCurrency";
import NiceModal from "@ebay/nice-modal-react";
import WheelAwardPopup from "@/features/invite/dialogInviteWheel/component/WheelAwardPopup/WheelAwardPopup";

import AmountPath from "./assets/bg_q.webp";
import { useGlobalState } from "@/store/commonStore";
import {
  InviteTurntableAward,
  InviteTurnTableSpin,
  useShareSpinInfo,
} from "@/store/shareSpin";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import {
  dealAmount2Fiexd,
  NumberMinus,
  dealAmountAnyValid,
} from "@/Core/utils/currencyDealCenter";
import useDialogManager from "@/utils/useDialogManager";
import { useBeforeSetting } from "@/store/beforeSetting";
import SpinUI from "@/componentsUI/Spin";
import { useNavigate } from "react-router-dom";
import useDialog from "@/utils/useDialog";
import CommonPopup from "@/pages/commonPopup";
import { feedback } from "@/utils/feedback";
import { completeInviteWheelEntry } from "@/features/modalOrchestrator/inviteWheelEntry";

const nowTime = Date.now();

const DialogInviteWheel = ({ onUnavailable }: { onUnavailable?: () => void }) => {
  const { isLogin } = useGlobalState();
  const navigate = useNavigate();
  const { closeAll } = useDialog();

  //const { data } = useGetInviteData();
  const { t } = useTranslationPlus();
  const currency = useCurrency();
  const [rotateInfo, setRotateInfo] = useState({
    index: 0,
    start: false,
    data: null,
  });
  const { openSignUp, openSharePage } = useDialogManager();
  const { data: sitting } = useBeforeSetting();
  const { data, isLoading: isMutating, error, mutate } = useShareSpinInfo();
  const { isMutating: rotateLoading, trigger } = InviteTurnTableSpin();
  const { trigger: triggerAward, isMutating: getAwardMutating } =
    InviteTurntableAward();
  const inviteLink = buildInviteLink(data, true);
  const openWheelSharePage = () => {
    if (!inviteLink) {
      feedback.error(t("ERROR_DATA"));
      return;
    }
    openSharePage({
      shareSpin: true,
      inviteData: { inviteUrl: data?.inviteUrl, inviteCode: data?.inviteCode },
    });
  };

  useEffect(() => {
    if (isLogin && onUnavailable && (error || (!isMutating && !data))) {
      onUnavailable();
    }
  }, [data, error, isLogin, isMutating, onUnavailable]);

  const isSelf = useMemo(() => {
    return (
      !data?.invitationUserId ||
      data?.helpInviteUser ||
      (!data?.helpInviteUser && !data?.inviterIsStartActivity)
    );
  }, [data]);

  // 抽奖次数
  const [times, setTimes] = useState(0);

  // 活动状态
  const [status, setStatus] = useState("");

  // 活动信息
  const [info, setInfo] = useState({
    // 总金额
    total: "948.98",
    // 进度
    progress: "90",
    // 剩余金额
    rest: "10.00",
  });

  const [isLoading, setIsLoading] = useState(true);

  const rotateImageRef = useRef(null);

  // 开始抽奖
  const onDraw = async () => {
    console.log("[InviteWheel] onDraw: start", {
      isLogin,
      isSelf,
      spinBool: data?.spinBool,
      rotateStart: rotateInfo?.start,
      currentRounds: data?.currentRounds,
      totalRounds: data?.totalRounds,
      needBindPhone: data?.needBindPhone,
      bindPhone: data?.bindPhone,
      invitationUserId: data?.invitationUserId,
      helpInviteUser: data?.helpInviteUser,
      startActivity: data?.startActivity,
    });
    // 强制登录
    if (!isLogin) {
      console.log("[InviteWheel] onDraw: blocked - not login");
      feedback.error(t("Affiliate.AFFILIATE-21"));
      openSignUp();
      return;
    }

    // 有上级并且在需要绑定手机号的情况下没有绑定手机号
    if (!isSelf && !data?.bindPhone && data?.needBindPhone) {
      console.log("[InviteWheel] onDraw: blocked - need bind phone");
      // 绑定手机号
      NiceModal.show(CommonPopup, {
        ontentText: t("Affiliate.AFFILIATE-14"),
        rightBtnText: t("GameOriginal.Confirm"),
        leftCallback: ({ remove }) => {
          remove();
        },
        rightCallback: ({ remove }) => {
          remove();
          closeAll();
          navigate("/globalSettings/1?redirect=inviteTable");
        },
      });
      return;
    }

    if (data?.currentRounds >= data?.totalRounds) {
      console.log("[InviteWheel] onDraw: blocked - rounds finished", {
        currentRounds: data?.currentRounds,
        totalRounds: data?.totalRounds,
      });
      feedback.info(t("Affiliate.AFFILIATE-17"));
      return;
    }

    // 是否可抽奖
    if (!data?.spinBool) {
      console.log("[InviteWheel] onDraw: blocked - no spin chance");
      //提示次数不够 前往邀请好友助力
      openWheelSharePage(); //次数不够直接弹出分享弹窗
      // handlerCopy(data?.inviteUrl, data?.inviteCode)
      // NiceModal.show(CommonPopup, {
      //     ontentText: t('shareFriendWheel.text-13'),
      //     rightBtnText: t('GameOriginal.Confirm'),
      //     leftCallback: ({ remove }) => {
      //         remove();
      //     },
      //     rightCallback: ({ remove }) => {
      //         remove();
      //         handlerCopy(data?.inviteUrl, data?.inviteCode)
      //     },
      // });
      return;
    }

    //正在旋转中
    if (rotateInfo.start) {
      console.log("[InviteWheel] onDraw: blocked - already rotating");
      return;
    }

    try {
      // const data = await trigger()

      // const { type } = data
      // if (type === 4) {
      //     // sacar
      //     setRotateInfo({
      //         index: 0,
      //         start: true,
      //         data,
      //     })
      // } else if (type === 3) {
      //     // 不中奖
      //     setRotateInfo({
      //         index: 3,
      //         start: true,
      //         data,
      //     })
      // } else if (type === 2) {
      //     //金币
      //     const randomIndex = Math.floor(Math.random() * 2)
      //     const index = randomIndex === 1 ? 5 : 2
      //     setRotateInfo({
      //         index: index,
      //         start: true,
      //         data,
      //     })
      // } else if (type === 1) {
      //     // 金额
      //     const randomIndex = Math.floor(Math.random() * 2)
      //     const index = randomIndex === 1 ? 4 : 1
      //     setRotateInfo({
      //         index: index,
      //         start: true,
      //         data,
      //     })
      // }

      const data = await trigger();
      console.log("[InviteWheel] onDraw: trigger success", {
        amount: data?.amount,
        currencyType: data?.currencyType,
        type: data?.type,
      });
      setTimes(0);

      // 如果amount为0且是助力状态，设置为不中奖
      if (data?.amount === 0 && !isSelf) {
        setRotateInfo({
          index: 3, // 不中奖
          start: true,
          data,
        });
      } else {
        // 金额
        const randomIndex = sample([1, 4]);
        setRotateInfo({
          index: randomIndex,
          start: true,
          data,
        });
      }

      console.log("rotateInfo", rotateInfo);
    } catch (e) {
      console.log("[InviteWheel] onDraw: trigger error", e);
      feedback.error(t(e?.code));
    }
  };

  // 活动进度进度计算
  const progressCalc = (score: number, surplus: number) => {
    return `${min([((score / (score + surplus)) * 100).toFixed(2), 100])}`;
  };

  useEffect(() => {
    if (isMutating) {
      setIsLoading(true);
    }
    if (!isLogin) {
      setIsLoading(false);
    }
    if (data) {
      setIsLoading(false);
    }

    if (data?.spinBool) {
      setTimes(1);
    }

    if (isLogin) {
      // 助力过或者没有上级的情况下，显示自己的
      if (data?.helpInviteUser || !data?.invitationUserId) {
        setInfo({
          total: `${dealAmountAnyValid(data?.score, 4, {
            currencyType: data?.currencyType,
          })}`,
          progress: progressCalc(data?.score, data?.surplusScore),
          rest: dealAmountAnyValid(data?.surplusScore, 4, {
            currencyType: data?.currencyType,
          }),
        });
      } else {
        // 显示上级的活动信息
        setInfo({
          total: `${dealAmountAnyValid(data?.inviterScore, 4, {
            currencyType: data?.currencyType,
          })}`,
          progress: progressCalc(data?.inviterScore, data?.inviterSurplusScore),
          rest: dealAmountAnyValid(data?.inviterSurplusScore, 4, {
            currencyType: data?.currencyType,
          }),
        });
      }
    }

    if (!isLogin) {
      setStatus(t("Affiliate.AFFILIATE-12"));
    } else if (!data?.invitationUserId || data?.startActivity) {
      setStatus(t("Affiliate.AFFILIATE-18"));
    } else if (!data?.helpInviteUser) {
      setStatus(t("Affiliate.AFFILIATE-12"));
    } else {
      setStatus(t("Affiliate.AFFILIATE-16"));
    }
  }, [isLogin, isMutating, data]);

  useEffect(() => {
    if (rotateInfo.start) {
      let steps = -1;
      const handleStep = () => {
        rotateImageRef.current.removeEventListener("animationend", handleStep);
        steps += 1;
        rotateImageRef.current.style.animation = "unset";
        rotateImageRef.current.style.transform = `translate(-50%, -32px) rotate(-5deg)`;
        setTimeout(() => {
          rotateImageRef.current.style.animationName = "Wheel-pointer-shark";
          rotateImageRef.current.style.animationFillMode = "forwards";
          if (steps === 0) {
            rotateImageRef.current.style.animationDuration = "0.12s";
            rotateImageRef.current.style.animationIterationCount = 18;
          } else if (steps === 1) {
            rotateImageRef.current.style.animationDuration = "0.2s";
            rotateImageRef.current.style.animationIterationCount = 3;
          } else if (steps === 2) {
            rotateImageRef.current.style.animationDuration = "1.2s";
            rotateImageRef.current.style.animationIterationCount = 1;
          } else if (steps === 3) {
            rotateImageRef.current.style.animation = "unset";
            rotateImageRef.current.style.transform =
              "translate(-50%, -32px) rotate(0deg)";
          }
          rotateImageRef.current.addEventListener("animationend", handleStep);
        });
      };
      handleStep();
    }
  }, [rotateInfo]);

  /* 复制回调 */
  const handlerCopy = debounce(() => {
    if (inviteLink && copy(inviteLink)) {
      feedback.success(t("inviteElement.INVITE-1"));
    }
  });

  // 转盘结束
  const handleFinishCallback = (result) => {
    // mutate()
    const { index, data: _data } = result;
    setRotateInfo({
      ...rotateInfo,
      start: false,
    });

    // if (index === 0) {
    //     //sacar
    //     //打开获得奖励
    //     NiceModal.show(WheelAwardPopup, {
    //         icon: <img src={SACARPath}></img>,
    //     })
    // } else if (index === 5 || index === 2) {
    //     //金币
    //     NiceModal.show(WheelAwardPopup, {
    //         text: dealAmount2Fiexd(data?.amount, {
    //             currencyType: data?.currencyType,
    //         }) + data?.currencyType,
    //         icon: <img src={GoldPath}></img>,
    //     })
    // } else if (index === 4 || index === 1) {
    //     NiceModal.show(WheelAwardPopup, {
    //         text: dealAmount2Fiexd(data?.amount, {
    //             currencyType: data?.currencyType,
    //         }),
    //         icon: <img src={AmountPath}></img>,
    //     })
    // }

    // 不中奖（index为3）或者amount为0的情况下不显示奖励弹窗
    if (index === 3 || _data?.amount === 0) {
      // 不显示奖励弹窗
    } else {
      let prefix = "";
      // 自己活动发起者
      if (isSelf) {
        prefix = "Affiliate.AFFILIATE-20";
      } else {
        // 助力者
        prefix = "Affiliate.AFFILIATE-15";

        setStatus(t("Affiliate.AFFILIATE-16"));
      }

      NiceModal.show(WheelAwardPopup, {
        text: t(prefix, {
          amount: dealAmountAnyValid(_data?.amount, 4, {
            currencyType: _data?.currencyType,
          }),
        }),
        icon: <img src={AmountPath}></img>,
      });
    }

    mutate();
    setRefreshTime(false);
    setTimeout(() => {
      setRefreshTime(true);
    }, 50);
  };

  const handleWithdraw = () => {
    if (!isLogin) {
      openSignUp();
      return;
    }

    if (data?.surplusScore > 0) {
      //就差一点点就可以提现成功,快去分享吧
      NiceModal.show(CommonPopup, {
        ontentText: t("shareFriendWheel.text-14"),
        rightBtnText: t("GameOriginal.Confirm"),
        rightCallback: ({ remove }) => {
          remove();
        },
      });
      return;
    }

    triggerAward()
      .then((res) => {
        // if (res) {
        //     feedback.success(t('Affiliate.BROKERAGE-7'))
        // } else {
        //     feedback.error(t('Affiliate.HISTORYTABLE-6'))
        // }
        //
        mutate();
      })
      .catch((e) => {
        //
        feedback.error(t(e?.code));
      });
  };

  const handleShare = () => {
    if (!isLogin) {
      openSignUp();
      return;
    }

    openWheelSharePage();
  };

  const timeInfo = useMemo(() => {
    if (data) {
      const delta = (data.endTime - data.nowTime) / 1000 / 60 / 60 / 24;
      return {
        hasDay: delta >= 1,
        nowT: data.endTime ? data.nowTime : 0,
        nextT: data.endTime,
      };
    }
  }, [data]);

  const [refreshTime, setRefreshTime] = useState(true);

  const scores = useMemo(() => {
    if (data) {
      const score = dealAmount2Fiexd(data?.score, {
        currencyType: data?.currencyType,
      });
      let cs = score;
      if (score.includes(",")) {
        cs = score.replace(",", ".");
      }
      return {
        score: score,
        surplusScore: NumberMinus(100, Number(cs)),
      };
    }
  }, [data]);

  const onInvite = async () => {
    console.log("[InviteWheel] onInvite: click", {
      isLogin,
      startActivity: data?.startActivity,
      spinBool: data?.spinBool,
      invitationUserId: data?.invitationUserId,
      helpInviteUser: data?.helpInviteUser,
    });
    if (!isLogin) {
      openSignUp();
    } else {
      await mutate();

      if (!data?.invitationUserId && !data?.startActivity) {
        NiceModal.show(CommonPopup, {
          title: t("Affiliate.AFFILIATE-13"),
          ontentText:
            "You haven't started the lucky wheel yet, do you want to start SPIN now?",
          leftBtnText: "CANCEL",
          rightBtnText: "Confirm",
          leftCallback: ({ remove }) => {
            remove();
          },
          rightCallback: ({ remove }) => {
            remove();
            console.log("[InviteWheel] onInvite: confirm start -> onDraw");
            onDraw(); // 用户确认后自动旋转转盘
          },
        });
      } else if (data?.spinBool) {
        console.log("[InviteWheel] onInvite: spinBool -> onDraw");
        onDraw();
      } else {
        console.log("[InviteWheel] onInvite: no spin chance -> openSharePage");
        openWheelSharePage(); //次数不够直接弹出分享弹窗
      }
    }
  };

  const onCopy = () => {
    console.log("[InviteWheel] onCopy: click", {
      startActivity: data?.startActivity,
      spinBool: data?.spinBool,
    });
    if (!data.startActivity) {
      NiceModal.show(CommonPopup, {
        title: t("Affiliate.AFFILIATE-13"),
        ontentText:
          "You haven't started the lucky wheel yet, do you want to start SPIN now?",
        leftBtnText: "CANCEL",
        rightBtnText: "Confirm",
        leftCallback: ({ remove }) => {
          remove();
        },
        rightCallback: ({ remove }) => {
          remove();
          console.log("[InviteWheel] onCopy: confirm start -> onDraw");
          onDraw(); // 用户确认后自动旋转转盘
        },
      });
    } else if (data?.spinBool) {
      // 如果用户有旋转次数，提示用户先旋转
      NiceModal.show(CommonPopup, {
        title: t("Affiliate.AFFILIATE-13"),
        ontentText:
          "You have a spin chance, would you like to spin the wheel now?",
        leftBtnText: "CANCEL",
        rightBtnText: "Confirm",
        leftCallback: ({ remove }) => {
          remove();
        },
        rightCallback: ({ remove }) => {
          remove();
          console.log("[InviteWheel] onCopy: confirm spin -> onDraw");
          onDraw(); // 用户确认后自动旋转转盘
        },
      });
    } else {
      console.log("[InviteWheel] onCopy: copy invite url");
      // 如果用户没有旋转次数，才执行复制功能
      handlerCopy();
    }
  };

  return (
    <DialogPlusPage
      header={<DialogWheelHeader onClose={onUnavailable ? undefined : completeInviteWheelEntry} />}
      dialogName={"DialogPlusPage"}
      className="dialog-invite-wheel"
    >
      <LoadingUI
        isLoading={isLoading}
        error={error}
        retryFunc={mutate}
        dataList={isLogin ? data : [1]}
      >
        <div className="head">
          <div className="inner">
            <div className="bg"></div>
            <div className="amount-content">
              <img src={MoneyPath} className="money-img"></img>
              <span className="money-text"> {currency} {info.total}</span>
              <ButtonUI
                onClick={handleWithdraw}
                className={"money-btn"}
                type={"primary"}
              >
                {getAwardMutating ? (
                  <SpinUI dot loading></SpinUI>
                ) : (
                  t("shareFriendWheel.sacar")
                )}
              </ButtonUI>
            </div>
          </div>

          <ProgressBar progress={info.progress} />

          {isLogin && !data?.helpInviteUser ? (
            <div className="descrption">
              <span>
                {t("Affiliate.AFFILIATE-22")} {info.rest}
              </span>
            </div>
          ) : (
            <div className="descrption">
              <span>{t("shareFriendWheel.text-1")}</span>
              <span className="text"> {info.rest} </span>
              <span>{t("shareFriendWheel.text-2")}</span>
            </div>
          )}
        </div>
        <div className="wheel-content-section">
          <div className="wheel-content">
            <img src={WheelBgPath} className="bg"></img>
            <img
              src={WheelPointerPath}
              className="wheel-pointer-img"
              ref={rotateImageRef}
            ></img>
            <Wheel
              isLoading={rotateLoading}
              isLogin={isLogin}
              timesNumber={times}
              onFinishCallback={handleFinishCallback}
              rotateInfo={rotateInfo}
              className="wheel"
              onClickRotate={onDraw}
            />
          </div>
        </div>

        {refreshTime ? (
          <div className="time-div">
            <span>{t("shareFriendWheel.text-3")}</span>
            {isLogin ? (
              <StatisticCountdown
                className={"time-number"}
                value={timeInfo?.nextT}
                now={timeInfo?.nowT}
                format={timeInfo?.hasDay ? "DD HH:mm:ss" : "HH:mm:ss"}
              />
            ) : (
              <StatisticCountdown
                className={"time-number"}
                value={nowTime + 24 * 60 * 60 * 1000 * 3}
                now={Date.now()}
                format={"DD HH:mm:ss"}
              />
            )}
          </div>
        ) : (
          <div className="time-div">
            <span>{t("shareFriendWheel.text-3")}</span>
          </div>
        )}

        <div className="tips-div" onClick={handleShare}>
          <span>{t("shareFriendWheel.text-4")}</span>
          <ShareIcon />
        </div>

        {isLogin && (
          <div className={"referBottom"}>
            <div className={"inputUI"}>
              <div className={"likeInput"}>
                <p>{inviteLink}</p>
                <ButtonUI className={"likeBtn"} onClick={onCopy}>
                  {t("inviteElement.INVITE-12")}
                </ButtonUI>
              </div>
            </div>
          </div>
        )}

        <UserList
          friendsList={data?.recordList || []}
          isLogin={isLogin}
          dataList={data?.userList}
          className="user-list"
        />
        <Help />

        <div className="operation">
          <button onClick={onInvite}>{status}</button>
        </div>
      </LoadingUI>
    </DialogPlusPage>
  );
};

export default DialogInviteWheel;
